import React, { useEffect, useRef, useState } from "react";
import { Box, Flex, Text, VStack } from "@chakra-ui/react";

const sections = [
  ["NORA HUMAN", "People work", "better together.", "Modern HR infrastructure for growing Indian businesses."],
  ["01 — AUTOMATION", "Less admin.", "More progress.", "Payroll, attendance, onboarding and HR workflows in one system."],
  ["02 — COMPLIANCE", "Compliance", "without complexity.", "Structured processes, audit trails and India-focused HR controls."],
  ["03 — PEOPLE", "Human potential,", "automated.", "Give employees and managers better visibility, faster workflows and less operational friction."],
];

const LoginLeftPanelGradient = () => {
  const scrollerRef = useRef(null);
  const pauseAutoScroll = useRef(false);
  const [activeSection, setActiveSection] = useState(0);

  useEffect(() => {
    const scroller = scrollerRef.current;
    if (!scroller) return undefined;
    const onScroll = () => {
      const index = Math.round(scroller.scrollTop / scroller.clientHeight);
      setActiveSection(Math.min(Math.max(index, 0), sections.length - 1));
    };
    scroller.addEventListener("scroll", onScroll, { passive: true });
    return () => scroller.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const timer = window.setInterval(() => {
      const scroller = scrollerRef.current;
      if (!scroller || pauseAutoScroll.current || window.innerWidth < 768) return;

      const nextSection = (activeSection + 1) % sections.length;
      scroller.scrollTo({
        top: nextSection * scroller.clientHeight,
        behavior: "smooth",
      });
    }, 5000);

    return () => window.clearInterval(timer);
  }, [activeSection]);

  return (
    <Box ref={scrollerRef} onMouseEnter={() => { pauseAutoScroll.current = true; }} onMouseLeave={() => { pauseAutoScroll.current = false; }} onTouchStart={() => { pauseAutoScroll.current = true; }} onTouchEnd={() => { pauseAutoScroll.current = false; }} position="relative" width={{ base: "100%", md: "58%", lg: "62%", xl: "66%" }} h={{ base: "auto", md: "100dvh" }} overflowY={{ base: "visible", md: "auto" }} bg="#0B1324" bgGradient="linear-gradient(145deg, #0B1324 0%, #111C30 55%, #172238 100%)" color="#F8FAFC" sx={{ scrollSnapType: { md: "y mandatory" }, scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}>
      <VStack position="absolute" right="24px" top="50%" transform="translateY(-50%)" spacing={2} zIndex={5} display={{ base: "none", md: "flex" }}>
        {sections.map((section, index) => (
          <Box key={section[0]} w="4px" h={activeSection === index ? "28px" : "8px"} borderRadius="full" bg={activeSection === index ? "#D6A94A" : "rgba(255,255,255,0.25)"} transition="all 0.25s ease" />
        ))}
      </VStack>
      {sections.map(([label, firstLine, secondLine, description]) => (
        <Flex key={label} h={{ base: "auto", md: "100dvh" }} minH={{ base: "500px", md: "100dvh" }} scrollSnapAlign="start" scrollSnapStop="always" position="relative" px={{ base: 6, md: 10, lg: 12 }} py={{ base: 10, md: 8 }} direction="column" justify="center">
          <Text fontSize="11px" color="#D6A94A" mb={4} letterSpacing="0.12em">{label}</Text>
          <Text as="h1" fontSize={{ md: "38px", lg: "48px" }} fontWeight="600" lineHeight="1.08" maxW="520px">{firstLine}<br />{secondLine}</Text>
          <Text mt={5} color="whiteAlpha.700" maxW="420px">{description}</Text>
        </Flex>
      ))}
    </Box>
  );
};

export default LoginLeftPanelGradient;
